// import React, { useMemo, useCallback, useEffect } from "react";
// import {
//   Level,
//   LevelItem,
//   Label,
//   LabelColor,
//   Tooltip
// } from "@patternfly/react-core";

// import { useOkdProjectPods } from "../hooks/useOkdProjectPods";
// import DeploymentsSection from "../components/DeploymentsSection";

// const ProjectInfo = ({ project, userProfile, refreshCounter }) => {
//   const {
//     data: okdPods,
//     loading: okdPodsLoading,
//     error,
//     refetch,
//   } = useOkdProjectPods(project.name);

//   const memoPods = useMemo(() => okdPods ?? [], [okdPods]);

//   const handleRefetch = useCallback(() => {
//     refetch();
//   }, [refetch]);

//   useEffect(() => {
//     if (refreshCounter > 0) {
//       refetch();
//     }
//   }, [refreshCounter, refetch]);
  
//   return (
//     <>
//         <Level>
//           <LevelItem>
//             <Tooltip content="Project">
//               <Label color={LabelColor.blue} isCompact>PR</Label>
//             </Tooltip>{" "}
//             <b>{project.name}</b>
//           </LevelItem>

//           <LevelItem>
//             Status:{" "}
//             <Label
//               status={project.status === "Active" ? "success" : "warning"}
//               variant="outline"
//             >
//               {project.status}
//             </Label>
//           </LevelItem>
//         </Level>
//         <br />
//         <DeploymentsSection 
//           userProfile={userProfile}
//           deployments={project.deployments} 
//           pods={memoPods}
//         />
//     </>
//   );
// };

// export default ProjectInfo;

import React, { useMemo, useEffect } from "react";

import {
  Level,
  LevelItem,
  Label,
  LabelColor,
  Tooltip
} from "@patternfly/react-core";

import { useOkdProjectPods } from "../hooks/useOkdProjectPods";
import { useOkdProjectServices } from "../hooks/useOkdProjectServices";

import DeploymentsSection from "../components/DeploymentsSection";

const ProjectInfo = ({
  project,
  userProfile,
  refreshCounter
}) => {
  const {
    data: okdPods,
    refetch: refetchPods,
  } = useOkdProjectPods(project.name);

  const {
    data: okdServices,
    loading: servicesLoading,
    error: servicesError,
    refetch: refetchServices,
  } = useOkdProjectServices(project.name);

  const memoPods = useMemo(
    () => okdPods ?? [],
    [okdPods]
  );

  const memoServices = useMemo(
    () => okdServices ?? [],
    [okdServices]
  );

  useEffect(() => {
    if (refreshCounter > 0) {
      refetchPods();
      refetchServices();
    }
  }, [
    refreshCounter,
    refetchPods,
    refetchServices,
  ]);

  return (
    <>
      <Level>
        <LevelItem>
          <Tooltip content="Project">
            <Label color={LabelColor.blue} isCompact>
              PR
            </Label>
          </Tooltip>{" "}
          <b>{project.name}</b>
        </LevelItem>

        <LevelItem>
          Status:{" "}
          <Label
            status={
              project.status === "Active"
                ? "success"
                : "warning"
            }
            variant="outline"
          >
            {project.status}
          </Label>
        </LevelItem>
      </Level>

      <br />

      <DeploymentsSection
        userProfile={userProfile}
        deployments={project.deployments}
        pods={memoPods}
        services={memoServices}
        servicesLoading={servicesLoading}
        servicesError={servicesError}
      />
    </>
  );
};

export default ProjectInfo;